let accordion;

$(document).ready(($) => {
  // eslint-disable-next-line no-console
  console.log('%cLinku Novio', 'font-size: 2em; font-family: sans-serif; color: white; background-color:#18aaff; padding:4px 8px; border-radius: 4px');

  accordion = new Accordion(
    '.js-accordion',
    '.js-toggle-accordion',
    '.js-accordion-content',
  );

  accordion.initClickHandling();
});
